import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';

export const destroyEmployeeTimeOff = async (uuid: string) => {
  await CustomAxios.delete(`employee_time_offs/${uuid}`);
};

interface UseDestroyEmployeeTimeOffProps {
  uuid: string;
  onSuccessCallback?: () => void;
}

export function useDestroyEmployeeTimeOff({ uuid, onSuccessCallback }: UseDestroyEmployeeTimeOffProps) {
  return useMutation({
    mutationFn: () => destroyEmployeeTimeOff(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.employeeTimeOffAvailability],
      });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTimeOffs],
      });
      onSuccessCallback?.();
    },
    onError: (err: AxiosError) => {
      console.error('Error deleting employee time off:', err);
    },
  });
}
